"use client";

import { Container } from "@pamperedchef/design-system";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { BackToPrevious } from "@/composite/BackToPrevious";

import styles from "./back-to-previous.module.scss";

interface BackToPreviousProps {
	label?: string;
}

/**
 * BackToPrevious block component
 */
export function BackToPreviousBlock({
	label
}: BackToPreviousProps): JSX.Element | null {
	const t = useTranslations("Main");

	const [showBackButton, setShowBackButton] = useState(false);
	const [isBackNavigation, setIsBackNavigation] = useState(false);

	/**
	 * Detects back navigation
	 */
	function handleBackClick(): void {
		window.history.back();
	}

	/**
	 * Triggers after back navigation
	 */
	function handlePopState(): void {
		setIsBackNavigation(true);
	}

	useEffect(() => {
		const referrer = document.referrer;
		const currentDomain = window.location.origin;

		if (referrer.startsWith(currentDomain)) {
			setShowBackButton(true);
		}

		window.addEventListener("popstate", handlePopState);

		return (): void => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, []);

	if (isBackNavigation || !showBackButton) {
		return null;
	}

	return (
		<Container containerClassName={styles["container"]}>
			<BackToPrevious
				label={t(label || "goBack")}
				onClick={handleBackClick}
			/>
		</Container>
	);
}
